<template>
    <div class="challenge-rules">
        <div class="rules-container">
            <span v-for="rule in phases[0].rules" :key="rule.fundingRuleType" class="rule-text">
                {{ $t(`rules_ChallengeRules.${rule.fundingRuleType}`) }}
            </span>
        </div>
        <div @click="setCurrentPhase(phase)" v-for="(phase, i) in phases"
            :class="'step-container step-' + (i + 1) + ' ' + (currentPhase == phase ? 'selected ' : '') + ' ' + (phase.order > currentChallenge.lastPhase ? 'disabled' : '')"
            :key="phase.id+i">
            <span class="header-tag">
                {{ $t(`step`) + ' ' + (i + 1) }}
            </span>
            <div class="values-container">
                <span v-for="rule in phase.rules" class="rule-value" :key="i + rule.fundingRuleType">
                    {{ setFormat(phase, rule) }}
                </span>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    props: {
        phases: Array,
        currentPhase: Object,
        currentChallenge: Object,
        setCurrentPhase: Function
    },
    data: function () {

    },
    methods: {
        numberWithCommas(x) {
            return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
        },
        setFormat(phase, rule) {
            if (rule.fundingRuleType == 'TARGET') {
                return "$" + this.numberWithCommas((Math.abs(rule.value) - phase.initialBalance)) + " " + `(${Math.round((Math.abs(rule.value) / phase.initialBalance) * 100) - 100}%)`;
            }

            if (rule.fundingRuleType == 'MAX_DRAWDOWN' || rule.fundingRuleType == 'MAX_DAILY_LOSS') {
                return "$" + this.numberWithCommas(Math.abs(rule.value)) + " " + `(${Math.round((Math.abs(rule.value) / phase.initialBalance) * 100)}%)`;
            }

            if (rule.fundingRuleType == 'OVERNIGHT') {
                return "No"
            }

            return rule.value;
        }
    }
}
</script>

<style lang="scss">
.challenge-rules {
    display: flex;
    flex-direction: row;
    font-family: "Avenir", sans-serif;

    .rules-container {
        display: flex;
        flex-direction: column;
        margin-top: 96px;
        margin-right: auto;

        .rule-text {
            font-size: 20px;
            margin-bottom: 40px;
            font-weight: bold;

            &:last-of-type {
                margin-bottom: 0;
            }
        }
    }

    .step-container {
        position: relative;
        display: flex;
        flex-direction: column;
        margin-left: 100px;
        cursor: pointer;
        font-family: "Avenir", sans-serif;

        &:hover {
            .header-tag {
                background: #9A9A9A;
            }

            .values-container {
                background: 1px solid #9A9A9A;
            }
        }

        &.selected {
            .header-tag {
                background: var(--v-mainGreen-base);
                color: var(--v-mainWhite-base);
            }

            .values-container {
                border: 1px solid var(--v-mainGreen-base);
            }
        }

        &.disabled {
            cursor: not-allowed;

            .header-tag {
                background: #9A9A9A;
                color: #4E4E4E;
            }

            .values-container {
                background: var(--v-cardHeaderBackground-base);
            }
        }

        .header-tag {
            background: var(--v-cardHeaderBackground-base);
            border-top-left-radius: 10px;
            border-top-right-radius: 10px;
            color: var(--v-mainBlack-base);
            border: 1px solid transparent;
            text-align: center;
            font-size: 32px;
            font-weight: bold;
            padding: 5px 0;
            line-height: 1;
            width: 178px;
            margin: auto;
            padding-top: 10px;
            transition: background 0.225s ease-in-out;
        }

        .values-container {
            display: flex;
            flex-direction: column;
            align-items: center;
            border-radius: 15px;
            background: var(--v-cardBackground-base);
            color: var(--v-mainBlack-base);
            border: 1px solid #9A9A9A;
            padding: 40px 60px;
            transition: border 0.225s ease-in-out;

            .rule-value {
                font-size: 20px;
                margin-bottom: 40px;
                font-weight: normal;

                &:last-of-type {
                    margin-bottom: 0;
                }
            }
        }
    }

}
</style>